var _rect, _line, _line2, _line3, _line4, _line5, _line6, _path, _line7, _line8, _path2, _circle, _rect2, _line9, _line0, _line1, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLanglawCover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 640 360",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 640,
    height: 360,
    fill: "#111"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 60,
    x2: 640,
    y2: 60,
    stroke: "#fff",
    strokeWidth: 0.4,
    opacity: 0.05
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 300,
    x2: 640,
    y2: 300,
    stroke: "#fff",
    strokeWidth: 0.4,
    opacity: 0.05
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 320,
    y1: 90,
    x2: 320,
    y2: 275,
    stroke: "#fff",
    strokeWidth: 1.5,
    opacity: 0.25
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 185,
    y1: 155,
    x2: 455,
    y2: 155,
    stroke: "#fff",
    strokeWidth: 1.5,
    opacity: 0.25
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 185,
    y1: 155,
    x2: 165,
    y2: 200,
    stroke: "#4a7a3a",
    strokeWidth: 1,
    opacity: 0.7
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 185,
    y1: 155,
    x2: 205,
    y2: 200,
    stroke: "#4a7a3a",
    strokeWidth: 1,
    opacity: 0.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M155,200 Q185,225 215,200",
    fill: "none",
    stroke: "#4a7a3a",
    strokeWidth: 1.8,
    opacity: 0.85
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 455,
    y1: 155,
    x2: 435,
    y2: 195,
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.3
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 455,
    y1: 155,
    x2: 475,
    y2: 195,
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M425,195 Q455,220 485,195",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5,
    opacity: 0.35
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 320,
    cy: 90,
    r: 8,
    fill: "none",
    stroke: "#4a7a3a",
    strokeWidth: 1.5,
    opacity: 0.7
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 240,
    width: 64,
    height: 48,
    rx: 2,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.2
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 298,
    y1: 256,
    x2: 342,
    y2: 256,
    stroke: "#fff",
    strokeWidth: 0.8,
    opacity: 0.2
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    x1: 298,
    y1: 267,
    x2: 342,
    y2: 267,
    stroke: "#fff",
    strokeWidth: 0.8,
    opacity: 0.2
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    x1: 298,
    y1: 278,
    x2: 328,
    y2: 278,
    stroke: "#fff",
    strokeWidth: 0.8,
    opacity: 0.2
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 318,
    fontFamily: "Georgia, serif",
    fontSize: 10,
    fill: "#fff",
    opacity: 0.25,
    letterSpacing: 3
  }, "LANGLAW \xB7 RAG \xB7 LangChain")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 42,
    fontFamily: "Georgia, serif",
    fontSize: 9,
    fill: "#4a7a3a",
    letterSpacing: 4,
    opacity: 0.8
  }, "AI LEGAL ASSISTANT")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanglawCover);
export default __webpack_public_path__ + "static/media/langlaw-cover.443bc1235a035d65a8b9b2e9371b15b5.svg";
export { ForwardRef as ReactComponent };